import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import _ from 'lodash';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	LocationId: null as number | null,
	OrganizationId: null as number | null,
	Code: null as string | null,
	Description: null as string | null,
	Partofvillage: null as string | null,
	Street: null as string | null,
	City: null as string | null,
	Zipcode: null as number | null,
	StateId: null as number | null,
	VstupDat: null as Date | null,
	IsVirtual: null as number | null,
	LocationCode: null as number | null,
};

export type ProvozovnaIdDropDownList = DropdownItem & { selected: boolean };

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		StateId: [],
		OrganizationId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
